import React from 'react';
import PropTypes from 'prop-types';
import { ArrowLeft } from 'lucide-react';
import clsx from 'clsx';
import { useTheme } from '../context/ThemeContext';

// Reusable Footer Component
const ShippingFlowFooter = ({
  onBack,
  onSecondaryAction,
  onPrimaryAction,
  secondaryButtonText = 'Add another Leg',
  primaryButtonText = 'Continue to Checkout',
  primaryHelpText = '',
  showPrimaryButton = true,
  primaryButtonContainerClass = '',
  showSecondaryButton = true,
  disabled = false,
  showBack = false,
  className = ''
}) => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  const backButtonClassName = clsx(
    'flex items-center gap-2 text-xl transition-colors',
    {
      'text-slate-300 hover:text-white': isDark,
      'text-slate-600 hover:text-slate-900': !isDark
    }
  );

  const outlineButtonClassName = clsx(
    'w-full md:w-[300px] py-3 px-6 md:py-3 rounded-lg font-medium transition-colors border-2',
    {
      'border-slate-600 text-slate-300 hover:bg-slate-700 hover:text-white': isDark,
      'border-slate-300 text-slate-700 hover:bg-slate-50 hover:border-slate-400': !isDark
    },
    {
      'opacity-50 cursor-not-allowed': disabled
    }
  );

  const primaryButtonClassName = clsx(
    'w-full md:w-[300px] mt-4 md:mt-0 px-8 py-3 rounded-lg font-medium transition-colors md:ml-4',
    {
      'border-slate-700 bg-slate-700 hover:bg-slate-600 text-white': isDark,
      'border-slate-900 bg-slate-900 hover:bg-slate-700 text-white': !isDark
    },
    {
      'opacity-50 cursor-not-allowed': disabled
    }
  );

  const footerClassName = clsx(
    'flex flex-col-reverse gap-4 items-center md:flex-row  p-2',
    { 
      'justify-center md:justify-between': showBack,
      'justify-center md:justify-end': !showBack
    },
    {
      'bg-slate-800 border-slate-700': isDark,
      'bg-white border-slate-200': !isDark
    },
    className
  );

  return (
    <div className={footerClassName}>
      {showBack && 
        <button 
          onClick={onBack}
          className={backButtonClassName}
        >
          <ArrowLeft size={16} />
          Back
        </button>
      }

      <div className={clsx(
        'w-full flex-col items-center md:w-[80%] ',
        'md:flex md:flex-col md:justify-end md:items-end'
      )}>
        <div>
          {showSecondaryButton && (
            <button
              onClick={onSecondaryAction}
              className={outlineButtonClassName}
              disabled={disabled}
            >
              {secondaryButtonText}
            </button>
          )}
          {showPrimaryButton && (
            <button
              onClick={onPrimaryAction}
              className={primaryButtonClassName + ' ' + primaryButtonContainerClass}
              disabled={disabled}
            >
              {primaryButtonText}
            </button>
          )}
        </div>
        <div className="mt-4 text-sm text-center md:text-right text-slate-500 md:mt-4 md:ml-4">
          {primaryHelpText}
        </div>
      </div>
    </div>
  );
};

ShippingFlowFooter.propTypes = {
  onBack: PropTypes.func.isRequired,
  onSecondaryAction: PropTypes.func,
  onPrimaryAction: PropTypes.func.isRequired,
  secondaryButtonText: PropTypes.string,
  primaryButtonText: PropTypes.string,
  showPrimaryButton: PropTypes.bool,
  primaryButtonContainerClass: PropTypes.string,
  showSecondaryButton: PropTypes.bool,
  primaryHelpText: PropTypes.string,
  disabled: PropTypes.bool,
  showBack: PropTypes.bool,
  className: PropTypes.string
};

export default ShippingFlowFooter;